import React, { useEffect, useState } from 'react'
import {
  CCard,
  CCardBody,
  CCardHeader,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CButton,
  CNav,
  CNavItem,
  CNavLink,
  CTabContent,
  CTabPane,
} from '@coreui/react-pro'
import { Link } from 'react-router-dom'

const PricingPlanForMatchContest = ({
  teamCount,
  activationInfo,
  gameInfo,
  paidPlanTypes,
  totalPaidAmount,
  handlePayNow,
  invoiceLink,
}) => {
  const [activeTab, setActiveTab] = useState('tiered')
  const tableData = [
    { tier: '1-4 Teams', fee: '150' },
    { tier: '5-8 Teams', fee: '200' },
    { tier: '9-12 Teams', fee: '250' },
    { tier: '13-16 Teams', fee: '300' },
    { tier: '17-20 Teams', fee: '350' },
    { tier: '21+ Teams', fee: '400' },
  ]
  return (
    <div>
      <CCard>
        <CCardHeader>
          <strong>Pricing Plan - Match Contest</strong>
        </CCardHeader>
        <CCardBody>
          {/* Tabs */}
          <CNav variant="tabs">
            <CNavItem>
              <CNavLink active={activeTab === 'tiered'} onClick={() => setActiveTab('tiered')}>
                Tiered Pricing (Done-for-You)
              </CNavLink>
            </CNavItem>
            <CNavItem>
              <CNavLink
                active={activeTab === 'unlimited'}
                onClick={() => setActiveTab('unlimited')}
              >
                Unlimited Access (Do-It-Yourself, Self Scoring)
              </CNavLink>
            </CNavItem>
          </CNav>

          <CTabContent>
            {/* Tiered Pricing Tab */}
            <CTabPane visible={activeTab === 'tiered'}>
              <p className="mt-3">
                Ideal for clubs that want a guided setup and want us to handle match score updates
              </p>
              <CTable bordered className="mt-4">
                <CTableHead color="warning">
                  <CTableRow>
                    <CTableHeaderCell>Team Tiers</CTableHeaderCell>
                    <CTableHeaderCell>Per Month</CTableHeaderCell>
                    <CTableHeaderCell>3-Months</CTableHeaderCell>
                    <CTableHeaderCell>6-Months</CTableHeaderCell>
                    <CTableHeaderCell>12-Months</CTableHeaderCell>
                  </CTableRow>
                </CTableHead>
                <CTableBody>
                  {[
                    { tier: '1–4 Teams', month: '$50', three: '$150', six: '$300', twelve: '$600' },
                    { tier: '5–8 Teams', month: '$70', three: '$210', six: '$420', twelve: '$840' },
                    {
                      tier: '9–12 Teams',
                      month: '$90',
                      three: '$270',
                      six: '$540',
                      twelve: '$1,080',
                    },
                    {
                      tier: '13–16 Teams',
                      month: '$110',
                      three: '$330',
                      six: '$660',
                      twelve: '$1,320',
                    },
                    {
                      tier: '17–20 Teams',
                      month: '$130',
                      three: '$390',
                      six: '$780',
                      twelve: '$1,560',
                    },
                    {
                      tier: '21+ Teams',
                      month: '$150',
                      three: '$450',
                      six: '$900',
                      twelve: '$1,800',
                    },
                  ].map((item, index) => (
                    <CTableRow key={index}>
                      <CTableDataCell>{item.tier}</CTableDataCell>
                      <CTableDataCell>{item.month}</CTableDataCell>
                      <CTableDataCell>{item.three}</CTableDataCell>
                      <CTableDataCell>{item.six}</CTableDataCell>
                      <CTableDataCell>{item.twelve}</CTableDataCell>
                    </CTableRow>
                  ))}
                </CTableBody>
              </CTable>
              <p>We take care of score updates</p>
              <p>Unlimited Teams, Users, Players, Fixtures, and Analytics</p>
              <p>Fair use policy applies (30 fixtures to be scored per month)</p>
              <p>+$3/fixture applies for all fixtures above 30 fixtures</p>
              <p>
                <strong> Add Extra Months:</strong> A$50 / month (optional)
              </p>
            </CTabPane>

            {/* Unlimited Access Tab */}
            <CTabPane visible={activeTab === 'unlimited'}>
              <p className="mt-3">
                Team Count:{' '}
                <strong>
                  <Link to="/teams">{teamCount}</Link>{' '}
                </strong>
              </p>
              <p>You enter scores, we power everything else</p>
              <p>Unlimited Teams, Users, Players, Fixtures, Duration, and Admin Access</p>
              <p>Ideal for internal club competitions</p>
              {!activationInfo && gameInfo?.game_type !== 4 && (
                <CTable bordered className="mt-3">
                  <CTableHead>
                    <CTableRow color="warning">
                      <CTableHeaderCell>Team Tiers</CTableHeaderCell>
                      <CTableHeaderCell>Game Fee (in AUD)</CTableHeaderCell>
                      <CTableHeaderCell>Action</CTableHeaderCell>
                    </CTableRow>
                  </CTableHead>
                  <CTableBody>
                    {tableData.map((item, index) => {
                      const originalFee = parseInt(item.fee)
                      const planType = index + 1
                      const isPaid = paidPlanTypes.includes(planType)

                      const adjustedFee =
                        !isPaid && totalPaidAmount < originalFee
                          ? originalFee - totalPaidAmount
                          : originalFee <= totalPaidAmount
                          ? 0
                          : originalFee

                      return (
                        <CTableRow key={index}>
                          <CTableDataCell>{item.tier}</CTableDataCell>
                          <CTableDataCell>
                            AUD{' '}
                            {!isPaid && totalPaidAmount > 0 && originalFee > totalPaidAmount ? (
                              <span>
                                <del style={{ color: '#999' }}>{originalFee}</del>{' '}
                                <strong>{adjustedFee}</strong>
                              </span>
                            ) : (
                              originalFee
                            )}
                          </CTableDataCell>
                          <CTableDataCell>
                            {isPaid ? (
                              <span style={{ color: 'green', fontWeight: 'bold' }}>Paid</span>
                            ) : adjustedFee <= 0 ? (
                              <span style={{ color: 'green', fontWeight: 'bold' }}>Covered</span>
                            ) : (
                              <CButton
                                color="primary"
                                size="sm"
                                onClick={() => handlePayNow(adjustedFee, item.tier, planType)}
                              >
                                {totalPaidAmount > 0 ? 'Upgrade' : 'Pay Now'}
                              </CButton>
                            )}
                          </CTableDataCell>
                        </CTableRow>
                      )
                    })}
                  </CTableBody>
                </CTable>
              )}
              {!activationInfo && gameInfo?.game_type === 4 && (
                <div className="mt-3">
                  <stripe-pricing-table
                    pricing-table-id="prctbl_1Qk2wAItsmZf8AkXjYi6mFME"
                    publishable-key="pk_live_I2ZzJhqZwGTxEprRPJwLt4TE"
                  ></stripe-pricing-table>
                </div>
              )}
            </CTabPane>
          </CTabContent>
        </CCardBody>
      </CCard>
    </div>
  )
}

export default PricingPlanForMatchContest
